module.exports = __webpack_public_path__ + "static/media/promo-b-2.6a9e9792.png";